import { useTheme } from "@mui/material";
import { tokens } from "../theme";

export function useThemeColor() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return { theme, colors };
}
